
import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { LeafCollectionSummaryReportFIN } from './Pages';

export const LeafCollectionSummaryReportFINRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={LeafCollectionSummaryReportFIN} />
    </Fragment>
)